import { type FC, useEffect } from "react";
import { CheckCircle, CircleX, TriangleAlert } from "lucide-react";
import type { Toast } from "./NotificationProvider";
import styles from "./Notification.module.css";

interface Props extends Toast {
  onClose: (id: string) => void;
}

export const NotificationItem: FC<Props> = ({
  id,
  message,
  type,
  duration = 3500,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(id), duration);
    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  return (
    <div className={`${styles.notification} ${styles[type]}`}>
      <span className={styles.icon}>
        {type === "success" ? (
          <CheckCircle />
        ) : type === "warn" ? (
          <TriangleAlert />
        ) : (
          <CircleX />
        )}
      </span>
      <span className={styles.message}>{message}</span>
    </div>
  );
};
